import api from '../api/axios';

const getAll = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return api.get(`/scheduled-appointment${query ? `?${query}` : ''}`);
};

const create = (data) => api.post('/scheduled-appointment', data);

const update = (id, data) => api.patch(`/scheduled-appointment/${id}`, data);

const remove = (id) => api.delete(`/scheduled-appointment/${id}`);

const scheduledAppointmentsServices = {
  getAll,
  create,
  update,
  remove,
};

export default scheduledAppointmentsServices;
